export default __webpack_public_path__ + "static/media/placeholder_private03-es-mobile.83197077.png";